import React from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import _lowerCase from 'lodash/lowerCase'
import _startCase from 'lodash/startCase'

const styles = () => ({
  title: {
    fontWeight: 'bold',
  },
})

function DatePickerForm(props) {
  const {
    classes,
    label,
    value,
    handleOnChange,
  } = props
  const [selectedDate, setSelectedDate] = React.useState(value ? new Date(value) : new Date())

  const handleDateChange = (newDate) => {
    const [month, date, year] = new Date(newDate).toLocaleDateString('en-US').split('/')
    handleOnChange(`${year}-${month}-${date}`)
    setSelectedDate(newDate)
  }

  return (
    <Box mb={3}>
      <Box mb={1}>
        <Typography
          className={classes.title}
          variant="h6"
        >
          {_startCase(_lowerCase(label))}
        </Typography>
      </Box>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          inputVariant="outlined"
          clearable
          value={selectedDate}
          onChange={(date) => handleDateChange(date)}
          format="dd/MM/yyyy"
        />
      </MuiPickersUtilsProvider>
    </Box>
  )
}

DatePickerForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
}

export default withStyles(styles)(DatePickerForm)
